var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.form && _vm.form.id)?_c('a',{staticClass:"location-button",class:{ 'is-editor': _vm.isEditor, 'is-prod': !_vm.isEditor },style:({ backgroundColor: _vm.color, ..._vm.style }),attrs:{"href":'#' + _vm.formId},on:{"click":_vm.onClick}},[_c('i',{staticClass:"icon iconfont icontucengyemianbiaodanicon"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }